import React, { memo } from "react";
import "./style.scss";
import DicesSlider from "./DicesSlider";

const Dices = () => {
  return (
    <div className="Dices">
      <DicesSlider />
    </div>
  );
};

export default memo(Dices);
